import { render } from "./AuthorsTable.vue?vue&type=template&id=7f477982&scoped=true"
import script from "./AuthorsTable.vue?vue&type=script&lang=js"
export * from "./AuthorsTable.vue?vue&type=script&lang=js"

import "./AuthorsTable.vue?vue&type=style&index=0&id=7f477982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f477982"]])

export default __exports__